import { styled } from '@stitches/configed';
import { LoadingIcon } from '@you-go-vn/components';
import { useAppDispatch } from '../../store';
import { logoutDispatch } from '../profile/slide';

const Containter = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
});
const LogoutPage = () => {
  const dispatch = useAppDispatch();

  dispatch(logoutDispatch());
  return (
    <Containter>
      <div>
        <LoadingIcon />
        <div style={{ textAlign: 'center', marginTop: 8, fontSize: 16 }}>
          Đang đăng xuất...
        </div>
      </div>
    </Containter>
  );
};

export default LogoutPage;
